<template>
  <div class="cd columns is-multiline is-centered carfax-container" style="position: relative; z-index: 2000;" v-if="displayOnly">
    <!-- ⚠ THE LIVE-LINK BADGE, and the only one that can go stale. hasValidCarfaxRating tests only
         that dealerReportUrl is a non-empty string, so this branch drew a full-strength "report
         available" bar over a link CARFAX had already expired - Garrett, 17 Sep: "It showed me that
         the Carfax was good, but when I clicked on it, it said sorry." It now greys when the link is
         expired. The branches below are the STORED-report ones; they have no live link to lapse. -->
    <div class="column is-12" v-if="currentUserHasCarfaxSession && hasValidCarfaxRating">
      <div style="width:78px;" v-if="showIcons">
        <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeIcons(true)" v-tooltip="getCarFaxBbgTitle(true)" v-if="!carfaxRatingHasUrlOnly && !showResolveRecallButton"/>
        <inventory-recall-resolve-action :currentInventory="inventory" :usePortal="usePdfModalPortal" :isListMode="true" v-else-if="!carfaxRatingHasUrlOnly && showResolveRecallButton" :iconClass="'icon fa-1 is-pulled-right clickable'"></inventory-recall-resolve-action>
        <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeOwnerIcon(true)" v-tooltip="totalOwnersImageTitle"  v-if="!carfaxRatingHasUrlOnly && totalOwnersImageIndicator !== null && totalOwners > 0"/>
        <i class="icon fa-1 is-pulled-right" :class="getCarFaxVehicleUsageIconFontAwesomeIcons(true)" v-tooltip="getCarVehicleUsageTitle(true)" v-if="!carfaxRatingHasUrlOnly"/>
      </div>
      <a @click="showCarFaxReport()" style="width:78px; height:2px;" v-if="showIcons"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;" v-tooltip="getLastCheckedAt" :class="{'img-disabled': carfaxReportLinkExpired}"></a>
      <a @click="showCarFaxReport()" style="width:78px; height:2px;" v-else><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;" v-tooltip="getLastCheckedAt" :class="{'img-disabled': carfaxReportLinkExpired}"></a>
      <i class="fas fa-sync is-pulled-right" @click="getVehicleCarFaxRating" :class="{'fa-spin': isRefreshing}" v-if="this.vinNo && this.showRefresh" :style="{'margin-right': '10px', 'margin-top': '3px', 'font-size': '0.8rem', 'cursor': 'pointer', 'color': (refreshFailed === true ? '#FF6685' : '#4A4A4A') }"></i>
    </div>
    <div class="column is-12" v-else-if="!hideIfEmpty">
      <div v-if="hasHistoricalCarfaxRating && !hasCarfaxTesterRole">
        <div style="width:78px;" v-if="showIcons">
          <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeIcons(false)" v-tooltip="getCarFaxBbgTitle(false)" v-if="!carfaxRatingHasUrlOnly && !showResolveRecallButton"/>
          <inventory-recall-resolve-action :currentInventory="inventory" :usePortal="usePdfModalPortal" :isListMode="true" v-else-if="!carfaxRatingHasUrlOnly && showResolveRecallButton" :iconClass="'icon fa-1 is-pulled-right clickable'"></inventory-recall-resolve-action>
          <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeOwnerIcon(false)" v-tooltip="totalOwnersImageTitle"  v-if="!carfaxRatingHasUrlOnly && totalOwnersImageIndicator !== null && totalOwners > 0"/>
          <i class="icon fa-1 is-pulled-right" :class="getCarFaxVehicleUsageIconFontAwesomeIcons(false)" v-tooltip="getCarVehicleUsageTitle(false)" v-if="!carfaxRatingHasUrlOnly"/>
        </div>
        <a @click="showMostRecentCarfaxReportPdf" style="width:78px; height:2px;" v-if="showIcons"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;cursor: default;" v-tooltip="getLastCheckedAt"></a>
        <a @click="showMostRecentCarfaxReportPdf" style="width:78px; height:2px;" v-else><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;cursor: default;" v-tooltip="getLastCheckedAt"></a>
        <i class="fas fa-sync is-pulled-right" @click="getVehicleCarFaxRating" :class="{'fa-spin': isRefreshing}" v-if="this.vinNo && this.showRefresh" :style="{'margin-right': '10px', 'margin-top': '3px', 'font-size': '0.8rem', 'cursor': 'pointer', 'color': (refreshFailed === true ? '#FF6685' : '#4A4A4A') }"></i>
        <car-fax-login-control :key="currentUser.id" :inventory="inventory" :vinNo="vinNo" v-on:login-requested="loginRequested" :modalOnly="true" :showLoginModal="showLoginModal" v-on:on-close-login-modal="onLoginClosed"></car-fax-login-control>
      </div>
      <div v-else>
        <div style="width:78px;">
          <a style="width:78px; height:2px;" v-if="showIcons" @click="showMostRecentCarfaxReportPdf"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;cursor: default;" v-tooltip="getLastCheckedAt" class="img-disabled"></a>
          <a style="width:78px; height:2px;" v-else @click="showMostRecentCarfaxReportPdf"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;cursor: default;" v-tooltip="getLastCheckedAt" class="img-disabled"></a>
          <i class="fas fa-sync is-pulled-right" @click="getVehicleCarFaxRating" :class="{'fa-spin': isRefreshing}" v-if="this.vinNo && this.showRefresh" :style="{'margin-right': '10px', 'margin-top': '3px', 'font-size': '0.8rem', 'cursor': 'pointer', 'color': (refreshFailed === true ? '#FF6685' : '#4A4A4A') }"></i>
        </div>
        <car-fax-login-control :key="currentUser.id" :inventory="inventory" :vinNo="vinNo" v-on:login-requested="loginRequested" :modalOnly="true" :showLoginModal="showLoginModal" v-on:on-close-login-modal="onLoginClosed"></car-fax-login-control>
      </div>
    </div>
    <div class="column is-12" v-else-if="currentUserHasCarfaxSession && validVinNo && !hideIconWhenNoRating">
      <a @click="getVehicleCarFaxRating" style="width:78px; height:2px;"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;" v-tooltip="'Click to get CARFAX report'" class="img-disabled"></a>
      <i class="fas fa-sync is-pulled-right" @click="getVehicleCarFaxRating" :class="{'fa-spin': isRefreshing}" v-if="this.vinNo && this.showRefresh" :style="{'margin-right': '10px', 'margin-top': '3px', 'font-size': '0.8rem', 'cursor': 'pointer', 'color': (refreshFailed === true ? '#FF6685' : '#4A4A4A') }" v-tooltip="'Click to get CARFAX report'"></i>
    </div>
    <!-- ⚠ reportUrlForViewer, not carFaxReportUrl: when the live link could not be made good this
         modal shows the STORED PDF instead, in the same place, so the operator is not sent somewhere
         else to read the same report. isStoredPdf tells the viewer not to regenerate a file that is
         already a PDF. The tester gate is upstream in openStoredCarfaxReportPdf - this modal has no
         role test of its own on the iframe. -->
    <car-fax-report-control v-if="!modalContainer"
      title="CarFax Vehicle Status"
      v-on:on-hide-carfax-report="onHideCarFaxReport"
      :showCarFaxReportModal="showReport"
      :carFaxReportUrl="reportUrlForViewer"
      :isStoredPdf="storedCarfaxReportPdfUrl !== ''"
      :latestCarfaxReportUrl="latestCarfaxReportFileUrl">
    </car-fax-report-control>
    <pdf-modal
      :pdfFile="carfaxReportSelectedPdf"
      :usePortal="true"
      :portalOrder="2"
      v-on:on-pdf-downloaded="onPreviewed"
      v-on:on-pdf-closed="onPreviewClosed"
      v-if="carfaxReportSelectedPdf && carfaxReportSelectedPdf.src">
    </pdf-modal>
    <carfax-payment-required-control :key="currentUser.id" :inventory="inventory" :vinNo="vinNo" :showPaymentRequiredModal="isPaymentRequiredForReportActive" v-on:on-carfax-purchase-requested="onCarfaxPurchaseRequested" v-on:on-carfax-purchase-failed="onCarfaxPurchaseFailed" v-on:on-new-carfax-purchased="onCarfaxPurchased" v-on:on-carfax-login-required="onCarfaxLoginRequired" :useModalPortal="usePdfModalPortal" v-on:carfax-payment-modal-closed="onCarfaxPaymentModalClosed"></carfax-payment-required-control>
  </div>
  <div class="columns is-multiline is-centered carfax-container" style="position: relative; z-index: 2000;" :class="containerBoxed" v-else>
    <div class="carfax-container-display-only column is-12">
      <div style="width:100%">
        <h3 class="title is-6 is-inline-block is-marginless">{{title}}</h3>
        <label class="is-inline-block is-size-7 has-text-success refresh-status-label" v-if="isRefreshing"> Fetching latest available report...</label>
        <i class="fal fa-sync-alt clickable is-pulled-right" :class="{'fa-spin': isRefreshing}" @click="getVehicleCarFaxRating" v-if="this.vinNo && this.showRefresh"></i>
      </div>
    </div>
    <div class="column is-12" v-if="currentUserHasCarfaxSession && hasValidCarfaxRating">
      <div  class="columns">
        <div class="column is-6" style="margin-top: 15px">
          <div style="width:78px;" v-if="showIcons">
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeIcons(true)" :title="getCarFaxBbgTitle(true)" v-if="!carfaxRatingHasUrlOnly && !showResolveRecallButton"/>
            <inventory-recall-resolve-action :currentInventory="inventory" :usePortal="usePdfModalPortal" :isListMode="true" v-else-if="!carfaxRatingHasUrlOnly && showResolveRecallButton" :iconClass="'icon fa-1 is-pulled-right clickable'"></inventory-recall-resolve-action>
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeOwnerIcon(true)" :title="totalOwnersImageTitle" v-if="!carfaxRatingHasUrlOnly && totalOwnersImageIndicator !== null && totalOwners > 0"/>
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxVehicleUsageIconFontAwesomeIcons(true)" :title="getCarVehicleUsageTitle(true)" v-if="!carfaxRatingHasUrlOnly"/>
          </div>
          <a @click="showCarFaxReport()" style="width:78px; height:2px;" v-if="showIcons"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;" v-tooltip="getLastCheckedAt" :class="{'img-disabled': carfaxReportLinkExpired}"></a>
          <a @click="showCarFaxReport()" style="width:78px; height:2px;" v-else><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;" v-tooltip="getLastCheckedAt" :class="{'img-disabled': carfaxReportLinkExpired}"></a>
        </div>
        <div class="column is-6">
          <div class="field" v-if="hasCarfaxReportData && !hasCarfaxTesterRole">
            <file-selector v-model="carfaxReportData" label="Latest Report" :required="false" :multiple="false" :isBoxed="false" :enabled="false" displaySize="64" :usePortalViewer="false"></file-selector>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12"  v-else-if="!currentUserHasCarfaxSession && hasCarfaxTesterRole">
      <label class="label refresh-status-label">
      No CarFax report available
      </label>
    </div>
    <div class="column is-12" v-else-if="hasCarfaxReportData">
      <div  class="columns">
        <div class="column is-6">
          <div style="width:78px;" v-if="showIcons">
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeIcons(true)" v-tooltip="getCarFaxBbgTitle(true)" v-if="!carfaxRatingHasUrlOnly && !showResolveRecallButton"/>
            <inventory-recall-resolve-action :currentInventory="inventory" :usePortal="true" :isListMode="true" v-else-if="!carfaxRatingHasUrlOnly && showResolveRecallButton" :iconClass="'icon fa-1 is-pulled-right clickable'"></inventory-recall-resolve-action>
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxFontAwesomeOwnerIcon(true)" v-tooltip="totalOwnersImageTitle"  v-if="!carfaxRatingHasUrlOnly && totalOwnersImageIndicator !== null && totalOwners > 0"/>
            <i class="icon fa-1 is-pulled-right" :class="getCarFaxVehicleUsageIconFontAwesomeIcons(true)" v-tooltip="getCarVehicleUsageTitle(true)" v-if="!carfaxRatingHasUrlOnly"/>
          </div>
          <a style="width:78px; height:2px;" v-if="showIcons"><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px; cursor: default !important;" v-tooltip="getLastCheckedAt"></a>
          <a style="width:78px; height:2px;" v-else><img src="@/assets/static/carfax/CARFAX Connect Logo.svg" style="width:78px; height:22px;cursor: default !important;" v-tooltip="getLastCheckedAt"></a>
        </div>
        <div class="column is-6">
          <div class="field" v-if="hasCarfaxReportData && !hasCarfaxTesterRole">
            <file-selector v-model="carfaxReportData" label="Latest Report" :required="false" :multiple="false" :isBoxed="false" :enabled="false" displaySize="64" :usePortalViewer="false"></file-selector>
          </div>
        </div>
      </div>
    </div>    
    <div class="column is-12"  v-if="!hasRating && !hasRecentCarfaxReportPdf">
      <label class="label refresh-status-label">
      No CarFax report available
      </label>
    </div>
    <div class="column is-12" v-show="!isRefreshing && !currentUserHasCarfaxSession && showLogin && validVinNo && loginEnabled">
      <div class="notification is-info is-flex">
        <div>
          <i class="fas fa-info-circle is-info fa-2x"></i>
        </div>
        <div class="ml-10">
          Please login to CARFAX to get the latest available report.
        </div>
      </div>
      <car-fax-login-control :key="currentUser.id" :inventory="inventory" :vinNo="vinNo" v-on:login-requested="loginRequested"></car-fax-login-control>
    </div>
    <car-fax-report-control v-if="!modalContainer"
      v-tooltip="'CarFax Vehicle Status'"
      v-on:on-hide-carfax-report="onHideCarFaxReport"
      :showCarFaxReportModal="showReport"
      :carFaxReportUrl="carFaxReportUrl"
      :vinNo="vinNo"
      :latestCarfaxReportUrl="latestCarfaxReportFileUrl">
    </car-fax-report-control>
    <pdf-modal
      :pdfFile="carfaxReportSelectedPdf"
      :usePortal="usePdfModalPortal"
      :portalOrder="2"
      v-on:on-pdf-downloaded="onPreviewed"
      v-on:on-pdf-closed="onPreviewClosed"
      v-if="carfaxReportSelectedPdf && carfaxReportSelectedPdf.src">
    </pdf-modal>
    <carfax-payment-required-control :key="currentUser.id" :inventory="inventory" :vinNo="vinNo" :showPaymentRequiredModal="isPaymentRequiredForReportActive" v-on:on-carfax-purchase-requested="onCarfaxPurchaseRequested" v-on:on-carfax-purchase-failed="onCarfaxPurchaseFailed" v-on:on-new-carfax-purchased="onCarfaxPurchased" v-on:on-carfax-login-required="onCarfaxLoginRequired" :useModalPortal="usePdfModalPortal" v-on:carfax-payment-modal-closed="onCarfaxPaymentModalClosed"></carfax-payment-required-control>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import appraisalService from '@/services/appraisalService'
import { hasAttemptedCarfaxAutoRequest, markCarfaxAutoRequestAttempted } from '@/utils/carfax_auto_request'
import { hasCarfaxTesterRole } from '@/utils/carfax_roles'
import inventoryService from '@/services/inventoryService'
import CarFaxReportControl from '@/components/generic/CarFaxReportControl'
import CarFaxLoginControl from '@/components/generic/CarFaxLoginControl'
import userService from '@/services/userService'
import utilitiesMixin from '@/mixins/generic/utilities'
import eventBus from '@/eventBus'
import FileSelector from '@/components/generic/FileSelector'
import PdfModalDisplayComponent from '@/components/generic/PdfModalDisplayComponent'
import CarFaxPaymentRequiredControl from '@/components/generic/CarFaxPaymentRequiredControl'
import InventoryRecallResolveAction from '@/components/inventory/InventoryRecallResolveAction'

const mapDealerState = createNamespacedHelpers('dealer').mapState
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const carfaxUrlPrefixFormat = 'https://connect.carfax.com/dir?key='

export default {
  mixins: [utilitiesMixin],
  name: 'CarFaxControl',
  components: {
    'car-fax-report-control': CarFaxReportControl,
    'car-fax-login-control': CarFaxLoginControl,
    'file-selector': FileSelector,
    'pdf-modal': PdfModalDisplayComponent,
    'carfax-payment-required-control': CarFaxPaymentRequiredControl,
    'inventory-recall-resolve-action': InventoryRecallResolveAction
  },
  props: {
    vinNo: {
      type: String,
      default: ''
    },
    carFaxRating: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'CarFax Status'
    },
    autoUpdateInventory: {
      type: Boolean,
      default: false
    },
    /*
     * Request a report on mount when the record has none and the operator has a CARFAX session.
     *
     * ⚠ A NARROW PROP rather than runAutomatically, which gates four branches: it would also switch
     * on an on-carfax-failed emit for sessionless loads and an untagged on-new-carfax for records that
     * already hold a valid rating. Both are inert on ViewInventory today, but only by coincidence of
     * what that host binds - and neither expresses "once per session".
     *
     * ⚠ NO OTHER HOST DOES THIS. Every runAutomatically=true is a modal the operator deliberately
     * opened, and each binds the payment and failure events so it can handle them. The closest
     * analogue to a passive view screen, ViewApprovedPpaValue, sets it false on purpose. Garrett,
     * 17 Sep: "I don't want a scenario where the car has been put into stock without it having been
     * run."
     */
    autoRequestWhenMissing: {
      type: Boolean,
      default: false
    },
    runAutomatically: {
      type: Boolean,
      default: false
    },
    displayOnly: {
      type: Boolean,
      default: true
    },
    hideIfEmpty: {
      type: Boolean,
      default: true
    },
    inventory: {
      type: Object,
      default: null
    },
    modalContainer: {
      type: Boolean,
      default: false
    },
    latestCarfaxReport: {
      type: Object,
      default: null
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    inventoryType: {
      type: Object,
      default: null
    },
    purchasedFromType: {
      type: String,
      default: ''
    },
    inventoryTypeRequired: {
      type: Boolean,
      default: false
    },
    isBoxed: {
      type: Boolean,
      default: true
    },
    latestCarfaxReportPdf: {
      type: Object,
      default: null
    },
    loginEnabled: {
      type: Boolean,
      default: true
    },
    usePdfModalPortal:  {
      type: Boolean,
      default: true
    },
    resolveActionDisabled: {
      type: Boolean,
      default: false
    },
    hideIconWhenNoRating: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRefreshing: false,
      //Set by the refresh click and read once at the emit - see getVehicleCarFaxRating.
      userRequestedRefresh: false,
      currentCarFaxRating: null,
      showReport: false,
      showLogin: false,
      isLoginRequested: false,
      serverErrorMessage: '',
      isGettingUserCarfaxSession: false,
      showLoginModal: false,
      carfaxRatingReportUrl: '',
      refreshFailed: false,
      carfaxReportSelectedPdf: null,
      /*
       * The stored PDF currently being shown in the report modal, or '' for the live link.
       *
       * ⚠ Separate from carfaxReportSelectedPdf, which drives the OTHER modal (<pdf-modal>). This one
       * feeds the same viewer the live link uses, so the operator sees the report in one place.
       */
      storedCarfaxReportPdfUrl: '',
      isPaymentRequiredForReportActive: false
    }
  },
  computed: {
    ...mapUserGetters(['currentUser']),
    ...mapDealerState(['currentDealer']),
    ...mapConfigGetters(['definedTypes']),
    carFaxReportUrl: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.dealerReportUrl) {
        return this.currentCarFaxRating.dealerReportUrl
      } else {
        let result = 'https://www.carfaxonline.com/cfm/Display_Dealer_Report.cfm?partner=VAU_0&UID=' + this.currentDealer.carFaxUserName + '&vin=' + this.vinNo
        return result
      }
    },
    carFaxAvailable: function () {
      return this.currentCarFaxRating
    },
    totalOwnersImageIndicator: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.totalOwners && this.currentCarFaxRating.totalOwners > 0) {
        let totalOwners = this.currentCarFaxRating.totalOwners
        totalOwners = totalOwners > 3 ? 3 : totalOwners
        let imageName = 'ico_' + totalOwners + 'owner.png'
        return require(`@/assets/static/carfax/${imageName}`)
      }
      return null
    },
    totalOwners: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.totalOwners && this.currentCarFaxRating.totalOwners > 0) {
        let totalOwners = this.currentCarFaxRating.totalOwners
        return totalOwners
      }
      return 0
    },
    totalOwnersImageTitle: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.totalOwners && this.currentCarFaxRating.totalOwners > 0) {
        let totalOwners = this.currentCarFaxRating.totalOwners
        return totalOwners + ' owner(s) recorded.'
      }
      return ''
    },
    /*
     * The CARFAX bar's hover text, on all ten render sites across both trees.
     *
     * ⚠ IT SAYS WHETHER THE REPORT IS STALE, which is meeting change 5. The bar's appearance is
     * chosen by hasValidCarfaxRating, and that tests only that dealerReportUrl is a non-empty string -
     * no expiry - so a report whose CARFAX link lapsed days ago still draws the full black bar.
     * Garrett, 17 Sep: "It showed me that the Carfax was good, but when I clicked on it, it said
     * sorry." The click no longer dead-ends (showCarFaxReport re-pulls and falls back to the stored
     * PDF), so what was left was the badge claiming a freshness it had not checked.
     *
     * ⚠ Paired with the badge greying on the same condition (see the template). The tooltip came
     * first and the appearance followed, so both now read carfaxReportLinkExpired - if they ever
     * diverge, the bar and its hover text will contradict each other about the same report.
     *
     * ⚠ Keyed off carfaxReportLinkExpired, NOT hasValidCarfaxRating. The latter is the computed being
     * distrusted; gating on it would leave this silent in precisely the state it exists to describe.
     * Reused rather than re-derived, so the tooltip cannot disagree with the click path about what
     * "expired" means - notably that a MISSING reportExpiresAt counts as expired.
     */
    getLastCheckedAt: function () {
      let result = 'No Carfax report available.'
      if (this.currentCarFaxRating && this.currentCarFaxRating.lastCheckedAt) {
        let lastCheckedAt = this.$options.filters.formatDate(this.currentCarFaxRating.lastCheckedAt)
        //⚠ The stray ')' this replaced had no opening bracket - formatDate returns MM/DD/YYYY HH:mm
        //with none (main.js:111-119) - so the live tooltip read 'Last checked at 09/16/2026 20:00)'.
        result = 'Last checked at ' + lastCheckedAt + '.'
        if (this.carfaxReportLinkExpired) {
          result += ' This report is out of date - click to refresh it.'
        }
      }
      return result
    },
    hasRating: function () {
      return this.currentCarFaxRating !== null
    },
    currentUserHasCarfaxSession: function () {
      if (this.currentUser && this.currentUser.carFaxSession && this.currentUser.carFaxSession.hasValidSession) {
        return true
      }
      return false
    },
    validVinNo: function () {
      if (this.vinNo && this.vinNo !== '') {
        return true
      }
      return false
    },
    hasCarfaxReportData: function () {
      if (this.carfaxReportData && this.carfaxReportData.length > 0) {
        return true
      }
      return false
    },
    latestCarfaxReportFileUrl: function () {
      if (this.latestCarfaxReport && this.latestCarfaxReport.imageData) {
        return this.latestCarfaxReport.imageData
      } else if (this.inventoryLatestCarfaxReport && this.inventoryLatestCarfaxReport.imageData) {
        return this.inventoryLatestCarfaxReport.imageData
      }
      return ''
    },
    carfaxReportData: function () {
      if (this.latestCarfaxReport && this.latestCarfaxReport.imageData) {
        let carfaxData = []
        carfaxData.push(this.latestCarfaxReport)
        return carfaxData
      } else if (this.inventory && this.inventoryHasCarFaxReport) {
        let carfaxData = []
        carfaxData.push(this.inventoryLatestCarfaxReport)
        return carfaxData
      }
      return []
    },
    inventoryLatestCarfaxReport: function () {
      if (this.inventoryHasCarFaxReport) {
        return this.inventoryCarFaxReports[0]
      }
      return null
    },
    inventoryHasCarFaxReport: function () {
      if (!this.inventoryCarFaxReports || this.inventoryCarFaxReports === 0) {
        return false
      }
      let returnedValue = this.inventoryCarFaxReports.length > 0
      return this.inventoryCarFaxReports.length > 0
    },
    inventoryCarFaxReports: function () {
      if (!this.inventory || (!this.inventory.attachments && !this.inventory.allReports)) {
        return []
      }
      
      if (this.inventory && this.inventory.allReports && this.inventory.allReports.filter((y) => y.classType === 'CarFax').length > 0) {
        var allCarFaxReports = this.inventory.allReports.filter((y) => y.classType === 'CarFax')
        allCarFaxReports.sort(function(a,b){
          return new Date(b.createdAt) - new Date(a.createdAt)
        })   
        if (allCarFaxReports.length > 0) {
          let validReports = []
          validReports.push(allCarFaxReports[0])
          let result = []
          validReports.forEach((x) => {
            x.loaded = true
            x.imageData = x.fileLocation
            x.fileType = this.getFileType(x.fileLocation)
            var docUrl = process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(x.fileLocation)
            x.src = docUrl
            result.push(x)
          })
          return result
        } else {
          return []
        }
      } else if (this.inventory && this.inventory.attachments && this.inventory.attachments.filter((y) => y.classType === 'CarFax').length > 0) {
        var attachmentCarFaxReports = this.inventory.attachments.filter((y) => y.classType === 'CarFax')
        attachmentCarFaxReports.sort(function(a,b){
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
        if (attachmentCarFaxReports.length > 0) {
          let validReports = []
          validReports.push(attachmentCarFaxReports[0])
          let result = []
          validReports.forEach((x) => {
            x.loaded = true
            x.imageData = x.fileLocation
            x.fileType = this.getFileType(x.fileLocation)
            var docUrl = process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(x.fileLocation)
            x.src = docUrl
            result.push(x)
          })
          return result
        } else{
          return []
        }
      }
    },
    inventoryNewFromFactory: function () {
      if (this.inventoryTypeRequired && !this.inventoryType) {
        return true
      } else if (this.purchasedFromType && this.inventoryType) {
        if (this.inventoryType.id === 0 && this.purchasedFromType === 'Factory') {
          return true
        }
      }
      return false
    },
    //⚠ The shared predicate, not a fourth private copy of it. Byte-equivalent to the inline version
    //this replaces, so nothing about the answer changes - including that it returns TRUE when the
    //roles have not loaded, which is what makes every gate below fail closed.
    hasCarfaxTesterRole: function () {
      return hasCarfaxTesterRole(this.currentUser)
    },
    showIcons: function () {
      let result = true
      if (this.hasCarfaxTesterRole) {
        return false
      }
      if (!this.hasHistoricalCarfaxRating && !this.hasValidCarfaxRating) {
        result = false
      }
      return result
    },
    carfaxRatingHasUrlOnly: function () {
      if (this.currentCarFaxRating) {
        let currentRating = this.currentCarFaxRating
        if (!currentRating.totalAccidents && !currentRating.brandedTitle && !currentRating.buyBackGuarantee && !currentRating.airBagDeployed && !currentRating.recall && !currentRating.damaged && !currentRating.frameDamageOrRepair && !currentRating.majorProblems && !currentRating.totalOwners && !currentRating.totalServiceRecords && currentRating.dealerReportUrl && currentRating.reportExpiresAt) {
          return true
        }
      }
      return false
    },
    hasValidCarfaxRating: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.dealerReportUrl && this.currentCarFaxRating.dealerReportUrl.length > 0) {
        return true
      }
      return false
    },
    vehicleIsImport: function () {
      if (this.currentCarFaxRating && this.currentCarFaxRating.vehicleImportedDate && this.currentCarFaxRating.vehicleImportedSource && this.currentCarFaxRating.vehicleImportedComments) {
        return true
      }
      return false
    },
    containerBoxed: function () {
      if (this.isBoxed === true) {
        return 'box'
      }
      return ''
    },
    hasHistoricalCarfaxRating: function () {
      if (this.carFaxRating && this.carFaxRating.id) {
        return true
      }
      return false
    },
    hasLatestCarfaxReportPdf: function () {
      if (this.latestCarfaxReportPdf) {
        return true
      }
      return false
    },
    mostRecentCarfaxReportPdfData: function () {
      if (this.latestCarfaxReportPdf) {
        let validReports = []
        validReports.push(this.latestCarfaxReportPdf)
        let result = []
        validReports.forEach((x) => {
          x.loaded = true
          x.imageData = x.fileLocation
          x.fileType = this.getFileType(x.fileLocation)
          var docUrl = process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(x.fileLocation)
          docUrl = encodeURI(docUrl)
          x.src = docUrl
          result.push(x)
        })
        return result
      } else {
        if (this.inventory && this.inventory.allReports && this.inventory.allReports.filter((y) => y.classType === 'CarFax').length > 0) {
          var allCarFaxReports = this.inventory.allReports.filter((y) => y.classType === 'CarFax')
          allCarFaxReports.sort(function(a,b){
            return new Date(b.createdAt) - new Date(a.createdAt)
          })   
          if (allCarFaxReports.length > 0) {
            let validReports = []
            validReports.push(allCarFaxReports[0])
            let result = []
            validReports.forEach((x) => {
              x.loaded = true
              x.imageData = x.fileLocation
              x.fileType = this.getFileType(x.fileLocation)
              var docUrl = process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(x.fileLocation)
              docUrl = encodeURI(docUrl)
              x.src = docUrl
              result.push(x)
            })
            return result
          }
        } else if (this.inventory && this.inventory.attachments && this.inventory.attachments.filter((y) => y.classType === 'CarFax').length > 0) {
          var attachmentCarFaxReports = this.inventory.attachments.filter((y) => y.classType === 'CarFax')
          attachmentCarFaxReports.sort(function(a,b){
            return new Date(b.createdAt) - new Date(a.createdAt)
          })   
          if (attachmentCarFaxReports.length > 0) {
            let validReports = []
            validReports.push(attachmentCarFaxReports[0])
            let result = []
            validReports.forEach((x) => {
              x.loaded = true
              x.imageData = x.fileLocation
              x.fileType = this.getFileType(x.fileLocation)
              var docUrl = process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(x.fileLocation)
              docUrl = encodeURI(docUrl)
              x.src = docUrl
              result.push(x)
            })
            return result
          }
        }
      }
      return []
    },
    hasRecentCarfaxReportPdf: function () {
      if (this.mostRecentCarfaxReportPdfData && this.mostRecentCarfaxReportPdfData.length > 0) {
        return true
      }
      return false
    },
    isRecallResolved: function () {
      if (this.inventory && this.inventory.recallStatusTracker && this.inventory.carFaxRating && this.inventory.carFaxRating.recall === true && this.inventory.recallStatusTracker.recallStatus === 'Resolved') {
        return true
      }
      return false
    },
    /*
     * Whether the stored CARFAX link has passed the expiry CARFAX itself issued it with.
     *
     * ⚠ A MISSING expiry counts as expired, and that is the existing behaviour preserved rather than
     * a new rule: Date.parse(undefined) is NaN and `now > NaN` is false, so the mount hook needed a
     * second branch for it (the old :1257). Folding both into one test is the point - the click path
     * must not be able to disagree with the mount path about what "expired" means.
     *
     * ⚠ There is no 7-day constant here or anywhere in the repo. reportExpiresAt is CARFAX's own
     * value, copied verbatim by CarFaxService.cs:885-895; the 7 days is CARFAX's link validity.
     */
    //What the report modal actually displays: the stored PDF when one has been chosen, else the link.
    reportUrlForViewer: function () {
      return this.storedCarfaxReportPdfUrl !== '' ? this.storedCarfaxReportPdfUrl : this.carFaxReportUrl
    },
    carfaxReportLinkExpired: function () {
      if (!this.currentCarFaxRating) return false
      if (!this.currentCarFaxRating.reportExpiresAt) return true

      const expiresAt = Date.parse(this.currentCarFaxRating.reportExpiresAt)
      if (isNaN(expiresAt)) return true
      return new Date() > new Date(expiresAt)
    },
    carfaxDisplayInModal: function () {
      if (this.currentDealer?.carfaxReportDisplayOptionType === 'NewTab') {
        return false
      }
      return true
    },
    paymentRequireModalMessage: function () {
      if (this.vinNo && this.vinNo.length > 0) {
        return 'The CARFAX report for vehicle with vin number ' + this.vinNo + ' is not among your existing reports and will need to be purchased. Would you like to purchase the report?'
      }
      return 'The CARFAX report is not among your existing reports and will need to be purchased. Would you like to purchase the report?'
    },
    hasActiveRecall: function () {
      if (this.inventory && this.inventory.recallStatusTracker) {
        return true
      }
      return false
    },
    showResolveRecallButton: function (useCurrentCarfaxRating) {
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)
      let result = false
      if (carfaxRating && !this.resolveActionDisabled) {
        if (carfaxRating.accidentIndicator === true || carfaxRating.frameDamageOrRepair === true || carfaxRating.airBagDeployed === true) {
          result = false
        } else if (carfaxRating.damaged === true || carfaxRating.majorProblems === true) {
          result = false
        } else if (this.vehicleIsImport) {
          result = false
        } else if (this.hasActiveRecall === true && carfaxRating.recall === true) {
          result = true
        } else if (carfaxRating.brandedTitle === true) {
          result = false
        } else if (carfaxRating.totalAccidents && carfaxRating.totalAccidents > 0) {
          result = false
        } else {
          result = false
        }
      }
      return result
    }
  },
  methods: {
    getUpdatedCarFax: function () {
      let vinNo = this.vinNo
      let that = this
      if (this.currentUserHasCarfaxSession && this.isRefreshing === false && vinNo !== '') {
        this.isRefreshing = true
        appraisalService.getCarFax(vinNo, this.currentDealer).then(response => {
          that.isRefreshing = false
          if (response.errors) {
            that.$emit('on-carfax-failed')
            that.serverErrors = response.errors
          } else {
            that.currentCarFaxRating = response
            that.$emit('on-new-carfax', that.currentCarFaxRating)
            if (that.inventory && that.autoUpdateInventory) {
              that.currentCarFaxRating.inventoryId = that.inventory.id
              inventoryService.addCarFaxReport(that.currentCarFaxRating)
            }
          }
        }).catch((error) => {
          that.$emit('on-carfax-failed')
          that.isRefreshing = false
          that.serverErrorMessage = error.message
          that.currentCarFaxRating = null
        })
      } else {
        that.$emit('on-carfax-failed')
        that.isRefreshing = false
        that.currentCarFaxRating = null
      }
    },
    getCarFaxBbgTitle: function (useCurrentCarfaxRating) {
      let result = ''
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)
      if (carfaxRating) {
        if (carfaxRating.accidentIndicator === true || carfaxRating.frameDamageOrRepair === true || carfaxRating.airBagDeployed === true) {
          result = 'Indication of Accident, frame damage or airbag deployment.'
        } else if (carfaxRating.damaged === true || carfaxRating.majorProblems === true) {
          result = 'Damage indicated or major problems noted.'
        } else if (this.vehicleIsImport) {
          result = 'Vehicle has been flagged as a import.'
        } else if (carfaxRating.recall === true) {
          result = 'A recall has been flagged.'
        } else if (carfaxRating.brandedTitle === true) {
          result = 'Vehicle has been flagged with branded title.'
        } else if (carfaxRating.totalAccidents && carfaxRating.totalAccidents > 0) {
          result = 'Vehicle has at least one accident reported.'
        } else {
          result = 'No major incidents.'
        }
      }
      return result
    },
    getCarFaxFontAwesomeIcons: function (useCurrentCarfaxRating) {
      let classToAttach = {}
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)
      if (carfaxRating) {
        if (carfaxRating.accidentIndicator === true || carfaxRating.frameDamageOrRepair === true || carfaxRating.airBagDeployed === true) {
          classToAttach['fa'] = true
          classToAttach['fa-exclamation-triangle'] = true
          classToAttach['has-text-warning'] = true
        } else if (carfaxRating.damaged === true || carfaxRating.majorProblems === true) {
          classToAttach['fa'] = true
          classToAttach['fa-exclamation-triangle'] = true
          classToAttach['has-text-danger'] = true
          classToAttach['fa-rotate-180'] = true
        } else if (this.vehicleIsImport) {
          classToAttach['fal'] = true
          classToAttach['has-text-danger'] = true
          classToAttach['fa-ship'] = true
        } else if (carfaxRating.recall === true) {
          classToAttach['fal'] = true
          classToAttach['fa-repeat'] = true
          if (this.isRecallResolved === true) {
            classToAttach['has-text-success'] = true
          } else {
            classToAttach['has-text-danger'] = true
          }
        } else if (carfaxRating.brandedTitle === true) {
          classToAttach['fa'] = true
          classToAttach['fa-exclamation-triangle'] = true
          classToAttach['has-text-danger'] = true
          classToAttach['fa-rotate-180'] = true
        } else if (carfaxRating.totalAccidents && carfaxRating.totalAccidents > 0) {
          classToAttach['fa'] = true
          classToAttach['fa-exclamation-triangle'] = true
          classToAttach['has-text-danger'] = true
          classToAttach['fa-rotate-180'] = true
        } else {
          classToAttach['fa'] = true
          classToAttach['fa-check-square'] = true
          classToAttach['has-text-primary'] = true          
        }
      }
      return classToAttach
    },
    getCarFaxVehicleUsageIconFontAwesomeIcons: function (useCurrentCarfaxRating) {
      let classToAttach = {}
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)
      if (carfaxRating) {
        if (carfaxRating.vehicleUseType) {
          if (carfaxRating.vehicleUseType === 'Personal') {
            classToAttach['fal'] = true
            classToAttach['fa-house'] = true
          } else {
            classToAttach['fal'] = true
            classToAttach['fa-car-building'] = true
          }
        }
      }
      return classToAttach
    },
    getCarFaxFontAwesomeOwnerIcon: function (useCurrentCarfaxRating) {
      let classToAttach = {}
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)
      if (carfaxRating && carfaxRating.totalOwners !== null) {
        let totalOwners = carfaxRating.totalOwners
        if (totalOwners > 1) {
          classToAttach['fal'] = true
          classToAttach['fa-users'] = true

        } else {
          classToAttach['fal'] = true
          classToAttach['fa-user'] = true
        }
      }
      return classToAttach
    },
    /*
     * The CARFAX badge. Opens the live report, or - when the link cannot be made good - the stored PDF.
     *
     * ⚠ EXPIRY IS DECIDED HERE, not only in mounted. The mount-time re-pull is asynchronous, so an
     * operator who clicked before it resolved got the stale URL, and a record opened with no CARFAX
     * session was never checked at all. Dean, 20 Sep: re-pull first, fall back to the PDF, never
     * dead-end.
     */
    showCarFaxReport: function () {
      if (!this.currentUserHasCarfaxSession) {
        this.openStoredCarfaxReportPdf()
        return
      }
      if (!this.carfaxReportLinkExpired) {
        this.openLiveCarfaxReport()
        return
      }
      /*
       * ⚠ The link CARFAX issued has expired, so opening it would show CARFAX's own failure page.
       * Re-pull, and open whichever of the two we end up with.
       *
       * ⚠ This never purchases. getUpdatedCarfaxDealerReport's own error branch raises the
       * payment-required modal for the operator to act on deliberately - that stays deliberate.
       */
      const that = this
      Promise.resolve(this.getUpdatedCarfaxDealerReport()).then((outcome) => {
        if (outcome === 'refreshed') {
          that.openLiveCarfaxReport()
          return
        }
        /*
         * ⚠ AN ANSWER, NOT A FAILURE. The purchase modal is already up asking the operator whether to
         * buy the report, so there is nothing to fall back to - falling back here opened the stored PDF
         * beside it, or toasted "No CARFAX report PDF available" over it, which is untrue: the report
         * exists and simply has to be bought. Dean, 20 Sep: purchase modal only.
         */
        if (outcome === 'payment-required') return
        that.openStoredCarfaxReportPdf()
      })
    },
    //The live CARFAX link, exactly as it opened before - extracted so both callers share one copy.
    openLiveCarfaxReport: function () {
      if (this.carfaxDisplayInModal === true && this.hasCarfaxTesterRole === false) {
        this.displayCarfaxReportUrlInModal()
      } else {
        try {
          const parsedUrl = new URL(this.carFaxReportUrl)
          if (parsedUrl.protocol === 'https:' && parsedUrl.href.startsWith(carfaxUrlPrefixFormat)) {
            const carfaxWindow = window.open(this.carFaxReportUrl, '_blank')
            if (!carfaxWindow) {
              this.warningToast('Popup was blocked. Displaying CARFAX report in modal.')
              this.displayCarfaxReportUrlInModal()
            } else {
              this.$emit('on-close-carfax-report-handle-review')
            }
          } else {
            this.displayCarfaxReportUrlInModal()
          }
        } catch (error) {
          this.errorToast('Invalid CARFAX report URL')
        }
      }
    },
    /*
     * The stored PDF, shown where the live link would have been shown.
     *
     * ⚠ THE TESTER GATE LIVES HERE, ahead of BOTH routes, and that placement is the whole point. A
     * CARFAX tester is never shown a stored PDF anywhere in this app (carfax_roles.js; commit
     * c81aafcdde). Neither route below is role-aware on its own:
     *   - CarFaxReportControl renders its iframe on `carFaxReportUrl` with NO role test - only its
     *     buttons are gated - so handing it a PDF url would put the PDF in front of a tester.
     *   - window.open is not gated either.
     * Gating inside either one would leave the other open, so it is decided once, here.
     *
     * ⚠ The predicate FAILS CLOSED - unloaded roles read as a tester - which is deliberate and must
     * stay that way.
     */
    openStoredCarfaxReportPdf: function () {
      if (this.hasCarfaxTesterRole) {
        //⚠ Say so. showMostRecentCarfaxReportPdf keeps its toast INSIDE the role gate, so for a tester
        //the click did nothing at all and a withheld report looked identical to a broken button.
        this.failedToast('The CARFAX report is not available.')
        return
      }
      /*
       * ⚠ THE PDF CHECK COMES BEFORE THE SESSION CHECK, and the order is load-bearing. A stored PDF is
       * served from our own document/download and needs no CARFAX session at all - which is precisely
       * why a signed-out operator falls back to it. Testing the session first would cut them off from a
       * report they are entitled to read.
       */
      if (this.hasRecentCarfaxReportPdf !== true) {
        /*
         * ⚠ Name the reason. One message covered three different situations - no CARFAX session,
         * nothing ever stored, and a report that could not be produced - so the operator could not tell
         * which had happened and therefore could not tell what to do next. Dean, 20 Sep: say why.
         */
        if (!this.currentUserHasCarfaxSession) {
          this.failedToast('Sign in to CARFAX to view this report.')
        } else {
          this.failedToast('No CARFAX report has been stored for this vehicle.')
        }
        return
      }

      const storedPdf = this.mostRecentCarfaxReportPdfData[0]
      //⚠ Same presentation as the link, which is a PER-DEALER choice, not a fixed one: a NewTab dealer
      //must not suddenly get a modal just because the source changed from a link to a file.
      if (this.carfaxDisplayInModal === false) {
        const pdfWindow = window.open(storedPdf.src, '_blank')
        if (pdfWindow) return
        this.warningToast('Popup was blocked. Displaying CARFAX report in modal.')
      }
      this.storedCarfaxReportPdfUrl = storedPdf.src
      this.displayCarfaxReportUrlInModal()
    },
    displayCarfaxReportUrlInModal: function () {
      if (!this.modalContainer) {
        this.showReport = true
      } else {
      this.$emit('on-show-carfax-report')
      }
    },
    onHideCarFaxReport: function () {
      //⚠ Cleared on close, or the next click opens the previous vehicle's stored file instead of the
      //live link - reportUrlForViewer prefers the stored url whenever it is set.
      this.storedCarfaxReportPdfUrl = ''
      if (!this.modalContainer) {
        this.showReport = false
        this.$emit('on-close-carfax-report-handle-review')
      } else {
        this.$emit('on-hide-carfax-report')
      }
    },
    /*
     * ⚠ Returns a promise so callers can act on the OUTCOME, and it resolves to WHICH outcome, not
     * merely pass/fail:
     *   'refreshed'        a usable rating is in hand
     *   'payment-required' CARFAX will not serve this report until it is bought - the catch branch
     *                      below has ALREADY raised the purchase modal, so the caller must stand back
     *   'unavailable'      anything else: response errors, an empty response, a rejection, or it
     *                      declined to run
     *
     * ⚠ A boolean could not carry the middle case, and that cost a defect: needing to buy the report
     * looked identical to a dead re-pull, so the click path ran the PDF fallback straight over the
     * purchase modal - opening a second answer beside it, or toasting "No CARFAX report PDF available"
     * on top of it, which is not even true. Dean, 20 Sep: purchase modal only.
     */
    /*
     * Whether to pull a report nobody asked for.
     *
     * ⚠ ALL FIVE conditions, and each rules out a different harm: CARFAX is not withheld from this
     * user; the host must have opted in; no session means the request cannot succeed and would only
     * raise a login modal; an existing rating means there is nothing missing to fetch; an
     * already-attempted VIN stops a walk through the list grids from billing once per row opened.
     *
     * ⚠ THE ROLE CHECK IS THE ONLY AUTHORIZATION HERE, and it is first so it short-circuits the rest.
     * Every visible CARFAX affordance is already withheld from the tester role - the icons, the
     * report buttons, the stored PDF, even the progress header - so without this the whole UI is
     * hidden for that user and the component calls CARFAX on mount anyway, silently. e35304767b:
     * "for Carfax tester do not get Carfax automatically". This path simply never consulted it.
     *
     * ⚠ It does NOT mark the VIN attempted when it refuses. The predicate reports "tester" while the
     * roles are still loading, so marking here would turn a momentary fail-closed default into a
     * permanent silent refusal for that VIN for the rest of the page load.
     *
     * ⚠ currentUserHasCarfaxSession reads the live session, not a claim on the user object - a stale
     * session sends getUpdatedCarfaxDealerReport into its unconditional checkCarfaxLoginStatus, which
     * raises the login modal on page load.
     *
     * ⚠ A METHOD, NOT A COMPUTED, and that is load-bearing. It reads a module-level Set that Vue
     * cannot observe, so as a computed it cached its first answer and went stale - still reporting
     * "should request" after the request had already been made and recorded. It is called once from
     * mounted; a computed would also invite a template binding that silently shows the wrong state.
     */
    shouldAutoRequestCarfax: function () {
      if (this.hasCarfaxTesterRole) return false
      if (!this.autoRequestWhenMissing) return false
      if (!this.currentUserHasCarfaxSession) return false
      if (this.currentCarFaxRating) return false
      if (!this.vinNo) return false
      return !hasAttemptedCarfaxAutoRequest(this.vinNo)
    },
    /*
     * @param userInitiated whether an operator asked for this. DEFAULTS TRUE so every existing call
     *        site keeps the behaviour it has; only the mounted hook passes false.
     *
     * ⚠ IT DECIDES WHETHER THE PURCHASE MODAL MAY OPEN, and that is the whole reason it exists.
     * ViewInventory auto-requests a report for any record that has none - and a record with no rating
     * is precisely the record CARFAX holds no report for, so the automatic path lands on the
     * purchase-required branch far more often than the manual one does. That branch raises
     * CarFaxPaymentRequiredControl, which is can-cancel="false" with a primary "Yes" wired straight to
     * a billable purchase. On a page nobody asked anything of, arrived at by arrowing the grid
     * quickview, that is a forced spend decision per row. Dean, 21 Sep: suppress it on the auto path.
     *
     * ⚠ The outcome is still reported as 'payment-required' on BOTH paths. Callers need to tell a
     * needs-buying failure from an unavailable one regardless of who asked.
     */
    getUpdatedCarfaxDealerReport: function (userInitiated = true) {
      let that = this
      let vinNo = this.vinNo
      let userId = this.currentUser.id
      /*
       * ⚠ CAPTURED, not returned early. checkCarfaxLoginStatus() below runs on every path and an
       * early return would silently skip it on the one path that actually calls CARFAX.
       */
      let refreshed = Promise.resolve('unavailable')
      //Whether CARFAX said the report must be bought, independent of whether a modal was raised.
      let paymentRequired = false
      if (this.isRefreshing === false && vinNo !== '') {
        that.$emit('on-carfax-requested')
        this.isRefreshing = true
        refreshed = appraisalService.getVehicleCarFaxUrlByVin(userId, vinNo).then(response => {
          that.isRefreshing = false
          if (response.errors) {
            that.serverErrors = response.errors
            that.currentCarFaxRating = null
            that.$emit('on-carfax-failed')
          } else {
            if (response) {
              that.currentCarFaxRating = response
              that.refreshFailed = false
            } else {
              that.currentCarFaxRating = null
              that.refreshFailed = true
            }
            that.$emit('on-new-carfax', that.currentCarFaxRating)
            if (that.inventory && that.autoUpdateInventory && that.currentCarFaxRating) {
              that.currentCarFaxRating.inventoryId = that.inventory.id
              that.addCarfaxRating()
            }
          }
          //⚠ The resolved value is the QUESTION the caller asked: is there a usable rating now? Both
          //failure shapes above - response.errors, and an empty response - leave it null.
          return that.currentCarFaxRating ? 'refreshed' : 'unavailable'
        }).catch((error) => {
          if (process.env.NODE_ENV !== 'production') {
            console.error('CarFax error:', error)
          }
          that.isRefreshing = false
          if (error.message === 'The requested report is not in your existing inventory of reports and will need to be purchased.') {
            paymentRequired = true
            //⚠ The MODAL is gated on who asked; the EMIT is not. Hosts still need to know, so the
            //badge can grey itself and say the report has to be bought.
            if (userInitiated) {
              that.isPaymentRequiredForReportActive = true
            }
            that.$emit('on-carfax-payment-required')
          } else {
            that.$emit('on-carfax-failed')
            that.serverErrorMessage = error.message
            that.currentCarFaxRating = null

            if (error.message === 'Failed to refresh CARFAX session for the primary user. Please contact your administrator.') {
              that.reloadUser()
            } else if (error.message === 'User session has expired, login required.') {
              that.reloadUser()
            }
          }
          /*
           * ⚠ Resolves rather than rethrows: every caller wants the outcome, not an exception.
           *
           * ⚠ And 'payment-required' is reported SEPARATELY from 'unavailable' because the branch
           * above has already put a question to the operator. Collapsing the two is what let the PDF
           * fallback talk over that modal.
           */
          //⚠ Read from the local, NOT from isPaymentRequiredForReportActive - that flag is now only
          //set when an operator asked, so reading it here would report the auto path as 'unavailable'
          //and the caller could no longer tell the two failures apart.
          return paymentRequired ? 'payment-required' : 'unavailable'
        })
      } else if (!this.isRefreshing) {
        /*
         * ⚠ ONLY when there is no VIN to ask about. This used to catch the in-flight case too, and
         * that case is reached constantly: the mounted hook re-pulls an expired link, so isRefreshing
         * is true for the whole round trip while the greyed badge sits there inviting the click that
         * lands here. It reported failure, nulled the rating and collapsed the CARFAX bar to "Click to
         * get CARFAX report" with a "no CARFAX stored" toast - then the original request resolved and
         * put it all back.
         *
         * ⚠ And it cleared isRefreshing, unlatching the guard, so the next click could start a
         * SECOND concurrent pull of a billable report.
         *
         * A refresh already running now simply falls through: the one in flight will answer, and the
         * caller gets 'unavailable' so an expired-link click still opens the stored PDF meanwhile.
         */
        this.$emit('on-carfax-failed')
        this.currentCarFaxRating = null
      }
      this.checkCarfaxLoginStatus()
      return refreshed
    },
    addCarfaxRating: function () {
      let that = this
      let vinNo = this.vinNo
      let userId = this.currentUser.id
      if (this.isRefreshing === false && vinNo !== '') {
        appraisalService.addCarFaxReport(userId, that.currentCarFaxRating).then(response => {
          if (response.errors) {
            that.serverErrors = response.errors
          } else {
            if (response) {
              that.currentCarFaxRating = response.carfaxRating
            }
            that.$emit('on-new-carfax', that.currentCarFaxRating)
            that.$emit('on-carfax-vehicle-information')
          }
        }).catch((error) => {
        })
      } else {
      }
      this.checkCarfaxLoginStatus()
    },
    onWindowFocus: function() {
      if (this.isLoginRequested) {
        this.getUserCheckCarfaxStatus()
      }
    },
    loginRequested: function () {
      this.isLoginRequested = true
    },
    getUserCheckCarfaxStatus: async function () {
      let currentSessionValue = this.currentUser && this.currentUser.carFaxSession && this.currentUser.carFaxSession.hasValidSession
      let that = this
      let userId = this.currentUser.id
      this.isRefreshing = true
      userService.getCarfaxSession(userId).then(response => {
        that.isRefreshing = false
        if (response.errors) {
          that.serverErrors = response.errors
        } else {
          let carfaxSession = response.carfaxSession
          that.$store.dispatch('user/setUserCarfaxSession', carfaxSession).then((x) => {
            if (!that.currentUser.carFaxSession || !that.currentUser.carFaxSession.hasValidSession) {
              that.failedToast('No CARFAX session detected.')
              if (currentSessionValue == true) {
                eventBus.$emit('refresh-current-user')
                that.checkCarfaxLoginStatus()
                that.$forceUpdate()
              }
            } else {
              this.isLoginRequested = false
              that.successToast('CARFAX session detected, request for updated CARFAX initiated.')
              that.getUpdatedCarfaxDealerReport()
            }
          }).catch((error) => {
            that.serverErrorMessage = error.message
            that.isRefreshing = false
          })
        }
      }).catch((error) => {
        that.serverErrorMessage = error.message
        that.isRefreshing = false
      })
    },
    checkCarfaxLoginStatus: function () {
      if (this.displayOnly && (!this.currentUser.carFaxSession || !this.currentUser.carFaxSession.hasValidSession)) {
        this.showLoginModal = true
      } else {
        if (!this.currentUser.carFaxSession || !this.currentUser.carFaxSession.hasValidSession) {
          this.showLogin = true
        } else {
          this.showLogin = false
        }
      }
    },
    loginTest: function () {
      this.showLoginModal = true
    },
    onLoginClosed: function () {
      this.showLoginModal = false
    },
    getCarVehicleUsageTitle: function (useCurrentCarfaxRating) {
      let result = ''      
      let carfaxRating = this.getCarfaxRatingByContext(useCurrentCarfaxRating)

      if (carfaxRating && carfaxRating.vehicleUseType) {
        if (carfaxRating.vehicleUseType === 'Personal') {
          result = 'Personal vehicle'
        }  else {
          result = 'Commercial vehicle'
        }
      }
      return result
    },
    /*
     * The refresh icon beside the badge - the control Garrett was clicking. It has SIX click handlers
     * in this template and NO internal caller, so reaching it always means the operator asked.
     *
     * ⚠ The flag is set HERE rather than inferred from the on-carfax-requested event, which was the
     * obvious route: getUpdatedCarfaxDealerReport emits that one too and runs from this component's
     * own mounted hook, so a record with an expired report would have raised the reconcile prompt on
     * load without anyone asking for it.
     */
    getVehicleCarFaxRating: function () {
      let userId = this.currentUser.id
      let that = this
      this.userRequestedRefresh = true
      let vinNo = this.vinNo
      let inventoryId = this.inventory ? this.inventory.id : 0
      if (this.currentUserHasCarfaxSession && this.isRefreshing === false && vinNo !== '') {
        that.$emit('on-carfax-requested')
        that.isRefreshing = true
        appraisalService.extractCarfaxRatingFromDealerReport(userId, vinNo, false, inventoryId).then(response => {
          if (response.errors) {
            that.isRefreshing = false
            that.serverErrors = response.errors
            that.currentCarFaxRating = null
            that.$emit('on-carfax-failed')
          } else {
            if (response) {
              that.currentCarFaxRating = response.carfaxRating
              //⚠ The history arrives on THIS response now. The server fetches the report and uploads
              //the PDF once, then runs both AI extractions against that one blob concurrently, so the
              //operator waits for the larger of the two rather than the sum. The browser could never
              //have overlapped them itself - the history extraction takes the blob URL the rating
              //extraction produces, so from here the two are a strict data dependency.
              that.applyDetailedHistory(response.detailedHistory)
            } else {
              that.currentCarFaxRating = null
            }
            //⚠ ONE false, at the end. It used to go false the moment the rating landed and true again
            //inside the chained history call, so the spinner stopped and restarted mid-operation -
            //which reads to the operator as a stall.
            that.isRefreshing = false
            //⚠ Read AND cleared as it is read, so one refresh raises the reconcile prompt at most once.
            //The refresh no longer produces a second emit - the history is applied from the same
            //response - but getDetailedHistoryFromCarfaxDealerReport still emits when a report purchase
            //carried no history, and clearing the flag keeps that emit from re-raising the box.
            //⚠ All three emit sites carry the context; only the refresh click ever sets the flag, so
            //the automatic paths report userRequested false, which is what they are.
            const userRequested = that.userRequestedRefresh
            that.userRequestedRefresh = false
            //⚠ A second argument, which every existing listener ignores: all four handler names bound
            //to this event take one parameter. No other host has to change.
            that.$emit('on-new-carfax', that.currentCarFaxRating, { userRequested: userRequested })
          }
        }).catch((error) => {
          that.isRefreshing = false
          if (error.message === 'The requested report is not in your existing inventory of reports and will need to be purchased.') {
            // show modal
            that.isPaymentRequiredForReportActive = true
            that.$emit('on-carfax-payment-required')
          } else {
            that.$emit('on-carfax-failed')
            that.serverErrorMessage = error.message
          }
        })

      } else {
        if (that.currentUserHasCarfaxSession === false) {
          that.showLoginModal = true
        } else if (!vinNo) {
          that.failedToast('Vin number required.')
        }
        that.$emit('on-carfax-failed')
        that.isRefreshing = false
      }
    },
    getVehicleCarFaxRatingPurchaseIfRequired: function () {
      let userId = this.currentUser.id
      let that = this
      let vinNo = this.vinNo
      let inventoryId = this.inventory ? this.inventory.id : 0
      if (this.currentUserHasCarfaxSession && this.isRefreshing === false && vinNo !== '') {
        that.$emit('on-carfax-requested')
        that.isRefreshing = true
        appraisalService.extractCarfaxRatingFromDealerReport(userId, vinNo, true, inventoryId).then(response => {
          if (response.errors) {
            that.isRefreshing = false
            that.serverErrors = response.errors
            that.currentCarFaxRating = null
            that.$emit('on-carfax-failed')
          } else {
            if (response) {
              that.currentCarFaxRating = response.carfaxRating
              //⚠ The history arrives on THIS response now. The server fetches the report and uploads
              //the PDF once, then runs both AI extractions against that one blob concurrently, so the
              //operator waits for the larger of the two rather than the sum. The browser could never
              //have overlapped them itself - the history extraction takes the blob URL the rating
              //extraction produces, so from here the two are a strict data dependency.
              that.applyDetailedHistory(response.detailedHistory)
            } else {
              that.currentCarFaxRating = null
            }
            //⚠ ONE false, at the end. It used to go false the moment the rating landed and true again
            //inside the chained history call, so the spinner stopped and restarted mid-operation -
            //which reads to the operator as a stall.
            that.isRefreshing = false
            //⚠ Read AND cleared as it is read, so one refresh raises the reconcile prompt at most once.
            //The refresh no longer produces a second emit - the history is applied from the same
            //response - but getDetailedHistoryFromCarfaxDealerReport still emits when a report purchase
            //carried no history, and clearing the flag keeps that emit from re-raising the box.
            //⚠ All three emit sites carry the context; only the refresh click ever sets the flag, so
            //the automatic paths report userRequested false, which is what they are.
            const userRequested = that.userRequestedRefresh
            that.userRequestedRefresh = false
            //⚠ A second argument, which every existing listener ignores: all four handler names bound
            //to this event take one parameter. No other host has to change.
            that.$emit('on-new-carfax', that.currentCarFaxRating, { userRequested: userRequested })
          }
        }).catch((error) => {
          that.isRefreshing = false
          that.$emit('on-carfax-failed')
          that.serverErrorMessage = error.message
        })
      } else {
        if (that.currentUserHasCarfaxSession === false) {
          that.showLoginModal = true
        } else if (!vinNo) {
          that.failedToast('Vin number required.')
        }
        that.$emit('on-carfax-failed')
        that.isRefreshing = false
      }
    },
    /*
     * Applies the detailed history onto the rating already in hand.
     *
     * Extracted so the combined response, a report purchase and the standalone fetch apply it
     * identically - they must not drift. The purchase popup calls the combined endpoint too and hands
     * its history on; the fetch is only the fallback for a purchase that carried none.
     */
    applyDetailedHistory: function (detailedHistory) {
      //⚠ The tester guard used to sit on the FETCH, so a CARFAX tester never saw history at all. The
      //server now always computes it, so the guard has to live here instead or a tester would start
      //seeing real event data beside a rating MakeSafe has deliberately blanked.
      if (!detailedHistory || !this.currentCarFaxRating || this.hasCarfaxTesterRole) {
        return
      }
      let that = this
      that.currentCarFaxRating.vehiclePurchaseDate = detailedHistory.vehiclePurchaseDate

      //⚠ lastServiceDate, NOT lastVehicleOfferedForSaleDate. The two come from DISJOINT event sets
      //server-side - DeriveVehicleHistory filters on "Vehicle offered for sale" and on "Vehicle serviced"
      //into separate accumulators - and they have separate columns. This read the offered date into both,
      //so the CARFAX overview printed one date twice while the source and comments below it, which were
      //always correct, described a different event.
      that.currentCarFaxRating.lastServiceDate = detailedHistory.lastServiceDate
      that.currentCarFaxRating.lastServiceSource = detailedHistory.lastServiceSource
      that.currentCarFaxRating.lastServiceComments = detailedHistory.lastServiceComments

      that.currentCarFaxRating.lastVehicleOfferedForSaleDate = detailedHistory.lastVehicleOfferedForSaleDate
      that.currentCarFaxRating.lastVehicleOfferedForSaleSource = detailedHistory.lastVehicleOfferedForSaleSource

      that.currentCarFaxRating.vehicleImportedDate = detailedHistory.vehicleImportedDate
      that.currentCarFaxRating.vehicleImportedSource = detailedHistory.vehicleImportedSource
      that.currentCarFaxRating.vehicleImportedComments = detailedHistory.vehicleImportedComments

      that.currentCarFaxRating.vehicleRecallDate = detailedHistory.vehicleRecallDate
      that.currentCarFaxRating.vehicleRecallSource = detailedHistory.vehicleRecallSource
      that.currentCarFaxRating.vehicleRecallComments = detailedHistory.vehicleRecallComments

      that.currentCarFaxRating.damageReportData = []
      if (detailedHistory.carfaxDamageReportData && detailedHistory.carfaxDamageReportData.length > 0) {
        that.currentCarFaxRating.damageReportData.push(...detailedHistory.carfaxDamageReportData)
      }

      if (that.inventory && that.inventory.id && that.inventory.id > 0) {
        that.currentCarFaxRating.inventoryId = that.inventory.id
        inventoryService.addCarFaxReport(that.currentCarFaxRating)
      }
    },
    /*
     * The standalone history fetch - the fallback for a report purchase whose response carried no
     * history. The refresh reads the history off its own combined response and never comes here; when
     * that response carries none, the rating is shown without it.
     */
    getDetailedHistoryFromCarfaxDealerReport: function () {
      this.isRefreshing = true
      let that = this
      let carfaxRating = this.currentCarFaxRating
      let vinNo = this.vinNo
      let inventoryId = that.inventory ? that.inventory.id : 0
      if (carfaxRating && carfaxRating.tempBlobUrl && !this.hasCarfaxTesterRole) {
        appraisalService.extractDetailedHistoryFromCarfaxDealerReport(carfaxRating.tempBlobUrl, vinNo, inventoryId).then(response => {
          if (response.errors) {
            that.serverErrors = response.errors
            that.isRefreshing = false
          } else {
            that.applyDetailedHistory(response.detailedHistory)
            that.isRefreshing = false
            //⚠ Read AND cleared as it is read, so one refresh raises the reconcile prompt at most once.
            //The refresh no longer produces a second emit - the history is applied from the same
            //response - but getDetailedHistoryFromCarfaxDealerReport still emits when a report purchase
            //carried no history, and clearing the flag keeps that emit from re-raising the box.
            //⚠ All three emit sites carry the context; only the refresh click ever sets the flag, so
            //the automatic paths report userRequested false, which is what they are.
            const userRequested = that.userRequestedRefresh
            that.userRequestedRefresh = false
            //⚠ A second argument, which every existing listener ignores: all four handler names bound
            //to this event take one parameter. No other host has to change.
            that.$emit('on-new-carfax', that.currentCarFaxRating, { userRequested: userRequested })
          }
        }).catch((error) => {
          that.serverErrorMessage = error.message
          that.isRefreshing = false
        })
      } else {
        this.isRefreshing = false
      }
    },
    onPreviewClosed: function () {
      this.closePdf()
      this.carfaxReportSelectedPdf = null
    },
    onPreviewed: function () {
    },
    closePdf () {
    },
    showMostRecentCarfaxReportPdf: function () {
      if (!this.hasCarfaxTesterRole) {
        if (this.hasRecentCarfaxReportPdf === true) {
          this.carfaxReportSelectedPdf = this.mostRecentCarfaxReportPdfData[0]
        } else {
          this.failedToast('No CARFAX report PDF available.')
        }
      }
    },
    getCarfaxRatingByContext(useCurrentCarfaxRating) {
      if (useCurrentCarfaxRating === true && this.hasValidCarfaxRating && this.carfaxRatingHasUrlOnly === false) {
        return this.currentCarFaxRating
      } else if (this.hasHistoricalCarfaxRating) {
        return this.carFaxRating
      }
      return null
    },
    onCarfaxPurchaseRequested: function () {
      this.$emit('on-carfax-requested')
      this.$emit('on-carfax-purchase-requested')
      this.isRefreshing = true
    },
    onCarfaxPurchaseFailed: function () {
      this.isRefreshing = false
      this.$emit('on-carfax-failed')
    },
    onCarfaxPurchased: function (carFaxRating, detailedHistory) {
      if (carFaxRating) {
        this.currentCarFaxRating = carFaxRating
        //⚠ The purchase popup calls the same combined endpoint, so the history is normally already here.
        //The fetch is the fallback for a response that carried none.
        if (detailedHistory) {
          this.applyDetailedHistory(detailedHistory)
        } else {
          this.getDetailedHistoryFromCarfaxDealerReport()
        }
      } else {
        this.currentCarFaxRating = null
      }
      this.$emit('on-new-carfax', this.currentCarFaxRating)
      this.$emit('show-status')
    },
    onCarfaxLoginRequired: function () {
      if (this.currentUserHasCarfaxSession === false) {
        this.showLoginModal = true
      } else if (!this.vinNo) {
        this.failedToast('Vin number required.')
      }
      this.$emit('on-carfax-failed')
      this.isRefreshing = false
    },
    onCarfaxPaymentModalClosed: function () {
      this.isPaymentRequiredForReportActive = false
      eventBus.$emit('carfax-request-cancelled')
    },
    reloadUser: async function () {
      let currentSessionValue = this.currentUser && this.currentUser.carFaxSession && this.currentUser.carFaxSession.hasValidSession
      let that = this
      let userId = this.currentUser.id
      this.isRefreshing = true
      userService.getCarfaxSession(userId).then(response => {
        that.isRefreshing = false
        if (response.errors) {
          that.serverErrors = response.errors
        } else {
          let carfaxSession = response.carfaxSession
          that.$store.dispatch('user/setUserCarfaxSession', carfaxSession).then((x) => {
            if (!that.currentUser.carFaxSession || !that.currentUser.carFaxSession.hasValidSession) {
              that.failedToast('No CARFAX session detected.')
              if (currentSessionValue == true) {
                eventBus.$emit('refresh-current-user')
                that.$forceUpdate()
              }
            }
          }).catch((error) => {
            that.serverErrorMessage = error.message
            that.isRefreshing = false
          })
        }
      }).catch((error) => {
        that.serverErrorMessage = error.message
        that.isRefreshing = false
      })
    }
  },
  watch: {
    carFaxRating: function (newValue, oldValue) {
      this.currentCarFaxRating = this.carFaxRating
      if (this.currentCarFaxRating && this.currentCarFaxRating.dealerReportUrl) {
        this.carFaxDealerReportUrl = this.currentCarFaxRating.dealerReportUrl  
      } else {
        this.carFaxDealerReportUrl = ''
      }
    }
  },
  mounted: function () {
    this.isLoginRequested = false
    window.addEventListener("focus", this.onWindowFocus)
    this.currentCarFaxRating = this.carFaxRating
    if (!this.currentUserHasCarfaxSession) {
      this.showLogin = true
      if (this.runAutomatically) {
        this.$emit('on-carfax-failed')
      }
    } else if (this.currentCarFaxRating) {
      //⚠ Two branches collapsed into one: the second tested for a MISSING expiry, which the computed
      //now treats as expired. Same outcome, one definition, and the click path reads the same one.
      if (this.carfaxReportLinkExpired) {
        /*
         * ⚠ INSIDE the branch, deliberately, NOT `&&` in the condition above. This is the wider auto
         * path - it fires on EVERY host, not just the one that opts in - so it needs the same gate.
         * But folding the check into the condition would drop a tester through to the `else if` and
         * EMIT the CARFAX rating to them, which is the opposite of withholding it. Nested, a tester
         * simply does nothing here.
         */
        if (!this.hasCarfaxTesterRole) {
          this.getUpdatedCarfaxDealerReport()
        }
      } else if (this.runAutomatically && this.currentCarFaxRating) {
        this.$emit('on-new-carfax',this.currentCarFaxRating)
      }
    } else if (this.runAutomatically || this.shouldAutoRequestCarfax()) {
      /*
       * ⚠ The record has no rating at all. runAutomatically is the existing behaviour for the modal
       * hosts; shouldAutoRequestCarfax is the view screens, and it carries its own guards.
       *
       * ⚠ The old `else if (this.runAutomatically)` tail that sat here was UNREACHABLE - reaching it
       * required currentCarFaxRating to be falsy, which made the branch above it unconditional on the
       * same flag. Deleted rather than carried forward.
       */
      /*
       * ⚠ CAPTURED BEFORE MARKING. markCarfaxAutoRequestAttempted records the VIN, so a second call
       * to shouldAutoRequestCarfax() below would answer false and the request would be reported as
       * operator-initiated - which is the exact opposite of what it is.
       */
      const autoRequested = this.shouldAutoRequestCarfax()
      if (autoRequested) {
        //⚠ Before the request, not after: failure and purchase-required must stop the retry too.
        markCarfaxAutoRequestAttempted(this.vinNo)
      }
      /*
       * ⚠ Only the AUTO path suppresses the purchase modal. runAutomatically reaches this same line
       * and keeps passing true, because those hosts are modals the operator deliberately opened - a
       * purchase question there is answering something they asked.
       */
      this.getUpdatedCarfaxDealerReport(!autoRequested)
    }
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.onWindowFocus)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .status-icon {
    width: 13px;
    height: 12px;
    margin-right:12px;
  }

  .carfax-container-display-only {
    display: inline-flex;
    flex-flow: row;
    align-items: center;
    margin-top:10px;
  }

  .carfax-container {
    margin-top: 20px;
    padding: 0;
    margin-left:0;
    margin-right:0;
  }

  .carfax-owner-icons {
    height: 12px;
    width: 12px;
    margin-top:-15px;
  }

  .carfax-warning {
    background-image: url('@/assets/static/carfax/ico_accident.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-danger {
    background-image: url('@/assets/static/carfax/ico_alert.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-recall {
    background-image: url('@/assets/static/carfax/ico_recall.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-ok {
    background-image: url('@/assets/static/carfax/ico_green_check.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .refresh-status-label {
    margin-left:1em;
  }

  .cd .column {
    padding:0;
  }
</style>
